export const FETCH_SOPS = {
  START: 'START_FETCH_SOPS',
  COMPLETE: 'COMPLETE_FETCH_SOPS',
  FAIL: 'FAIL_FETCH_SOPS',
  CLEANUP: 'CLEANUP_FETCH_SOPS',
}

export const CREATE_SOP = {
  START: 'START_CREATE_SOP',
  COMPLETE: 'COMPLETE_CREATE_SOP',
  FAIL: 'FAIL_CREATE_SOP',
}

export const DELETE_SOP = {
  START: 'START_DELETE_SOP',
  COMPLETE: 'COMPLETE_DELETE_SOP',
  FAIL: 'FAIL_DELETE_SOP',
}
